import { useState, useEffect } from "react";
import { Flame, Clock, Zap, Target, Trophy, Gamepad2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GameStats() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API}/mindfulness-games/stats`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setStats(res.data);
      } catch (e) { console.error(e); }
    })();
  }, []);

  if (!stats) return null;

  const cards = [
    { icon: Gamepad2, label: "Sessions", value: stats.total_sessions, color: "text-blue-600 bg-blue-50" },
    { icon: Clock, label: "Time Played", value: `${Math.round(stats.total_time_seconds / 60)}m`, color: "text-purple-600 bg-purple-50" },
    { icon: Zap, label: "Avg Score", value: stats.avg_score, color: "text-amber-600 bg-amber-50" },
    { icon: Flame, label: "Day Streak", value: stats.longest_streak, color: "text-orange-600 bg-orange-50" },
    { icon: Target, label: "Scored Games", value: stats.scored_sessions, color: "text-emerald-600 bg-emerald-50" },
    { icon: Trophy, label: "Best Scores", value: Object.keys(stats.best_scores).length, color: "text-indigo-600 bg-indigo-50" },
  ];

  return (
    <div data-testid="game-stats" className="bg-white rounded-xl shadow-lg p-6 border border-emerald-100">
      <h2 className="text-lg font-bold text-gray-900 mb-4">Your Game Stats</h2>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
        {cards.map(c => {
          const Icon = c.icon;
          return (
            <div key={c.label} className="text-center">
              <div className={`inline-flex p-2 rounded-full mb-1 ${c.color}`}>
                <Icon className="w-4 h-4" />
              </div>
              <p className="text-lg font-bold text-gray-900">{c.value}</p>
              <p className="text-[10px] text-gray-500">{c.label}</p>
            </div>
          );
        })}
      </div>

      {/* Best scores breakdown */}
      {Object.keys(stats.best_scores).length > 0 && (
        <div className="mt-4 pt-4 border-t border-gray-100">
          <h3 className="text-xs font-bold text-gray-600 mb-2">Personal Bests</h3>
          <div className="flex flex-wrap gap-2">
            {Object.entries(stats.best_scores).map(([type, data]) => (
              <div key={type} className="px-3 py-1.5 bg-gradient-to-r from-amber-50 to-yellow-50 border border-amber-200 rounded-full text-xs">
                <span className="font-semibold text-amber-800">{data.game_title}:</span>
                <span className="ml-1 font-bold text-amber-600">{data.score}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
